import {Injectable} from "@angular/core";
import {ITCIApplicationMonitoringProvider, TCITenantAppType} from "@tci/common";
import {TciTenantModelService} from "../../../../../ng-tenant/tci-tenant.model";
import {TciTenantService} from "../../../../../ng-tenant/tci-tenant.service";
import {Observable} from "rxjs";

@Injectable()
export class BaseSubmenuMonitoringFlowsService {
    monitoringSvc: ITCIApplicationMonitoringProvider;
    constructor(private tenantSvc: TciTenantService,
                private tenantModelSvc: TciTenantModelService) {
    }

    getMonitoringService(tenantType: TCITenantAppType): Observable<ITCIApplicationMonitoringProvider> {
        return this.tenantSvc.onInit().map(res => {
            const tenant = this.tenantModelSvc.getTenant(tenantType);
            const errMsg = "No monitoring provider for this application type: " + tenantType.toString();
            if (tenant) {
                const provider = tenant.getMonitoringServiceProvider();
                if (provider) {
                    return provider;
                } else {
                    console.warn(errMsg);
                    throw new Error(errMsg);
                }
            } else {
                console.warn(errMsg);
                throw new Error(errMsg);
            }
        });
    }
}
